const WIDGET_SRC =
  'https://api.ai-manager.website/widget/e7wxapvyNspuDlmvvQTmqpA7eS4vd7BZ5aQlt4rhRCydHnYL.js'
const WIDGET_TOKEN = 'e7wxapvyNspuDlmvvQTmqpA7eS4vd7BZ5aQlt4rhRCydHnYL'
const WIDGET_API_BASE = 'https://api.ai-manager.website/api/v1'
const HOST_SELECTOR = '[data-ai-stone-widget]'

interface WidgetInstance {
  destroy?: () => void
}

declare global {
  interface Window {
    __aiStoneWidgetLoaded?: boolean
    AiStoneWidget?: {
      mountWidget: (options: {
        token: string
        apiBase: string
        launcherId?: string | null
      }) => WidgetInstance | undefined
    }
  }
}

let scriptPromise: Promise<void> | null = null
// Целевое состояние: защищает от гонки login→logout, пока грузится бандл.
let desired = false
// Смонтированный инстанс: держим ради destroy() — только он останавливает
// фоновую работу бандла (polling/WebSocket/таймеры), снятие host этого не делает.
let instance: WidgetInstance | null = null

function loadScript(): Promise<void> {
  // Бандл уже загружен (в т.ч. сценарий повторного входа) — не переинжектим скрипт.
  if (window.AiStoneWidget) return Promise.resolve()
  if (scriptPromise) return scriptPromise

  scriptPromise = new Promise<void>((resolve, reject) => {
    // Гасим авто-бутстрап IIFE: монтируем вручную, чтобы держать гейт по авторизации.
    window.__aiStoneWidgetLoaded = true
    const el = document.createElement('script')
    el.src = WIDGET_SRC
    el.async = true
    el.addEventListener('load', () => resolve())
    el.addEventListener('error', () => {
      el.remove()
      scriptPromise = null
      reject(new Error('Не удалось загрузить бандл виджета'))
    })
    document.body.appendChild(el)
  })

  return scriptPromise
}

export async function mountSupportWidget(): Promise<void> {
  desired = true
  if (instance) return

  try {
    await loadScript()
  } catch (error) {
    // Сеть/CDN недоступны — виджет просто не появится, приложение не роняем.
    console.error('[support-widget]', error)
    return
  }

  // Разлогинились или уже смонтировано, пока грузился бандл — не монтируем.
  if (!desired || instance) return

  instance =
    window.AiStoneWidget?.mountWidget({ token: WIDGET_TOKEN, apiBase: WIDGET_API_BASE }) ?? null
}

export function unmountSupportWidget(): void {
  desired = false
  instance?.destroy?.()
  instance = null
  // Fallback на старый закэшированный бандл без destroy(): host всё равно снимаем,
  // чтобы виджет не остался видимым после логаута.
  document.querySelector(HOST_SELECTOR)?.remove()
}
